import { PageContainer } from "../../common/components/page-container/PageContainer";
import { usePageTitle } from "../../common/hooks";

const ImprovHistoryPage = () => {
    usePageTitle("title.history");

    return (<PageContainer>
        <p>ImprovHistoryPage</p>;
    </PageContainer>)
}
export default ImprovHistoryPage;
